import { render, staticRenderFns } from "./batchPayConfirm.vue?vue&type=template&id=26146b28&scoped=true"
import script from "./batchPayConfirm.vue?vue&type=script&lang=js"
export * from "./batchPayConfirm.vue?vue&type=script&lang=js"
import style0 from "./batchPayConfirm.vue?vue&type=style&index=0&id=26146b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26146b28",
  null
  
)

export default component.exports